import request from '@/utils/request'

// 基础信息列表
export function getShowAdvert(data) {
  return request({
    url: `/tbAdvert/getShowAdvert`,
    method: 'get',
    params: data
  })
}
